<!-- clinicajure-staff-app/src/components/StaffLogin.vue -->
<template>
  <div class="login-container">
    <h2>Acceso para Personal de Clínica</h2>
    <form @submit.prevent="handleLogin">
      <input type="email" v-model="email" placeholder="Email" required />
      <input type="password" v-model="password" placeholder="Contraseña" required />
      <button type="submit">Entrar</button>
    </form>
    <p v-if="error" class="error-message">{{ error }}</p>
  </div>
</template>

<script>
import { auth } from '@/firebaseConfig'; // Importamos el servicio de autenticación
import { signInWithEmailAndPassword } from 'firebase/auth'; // La función para iniciar sesión

export default {
  name: 'StaffLoginComponent',
  data() {
    return {
      email: '', // Para el email del personal
      password: '',
      error: null,
    };
  },
  methods: {
    async handleLogin() {
      this.error = null; // Limpiar errores previos
      try {
        await signInWithEmailAndPassword(auth, this.email, this.password);
        
        // Si llegamos aquí, el inicio de sesión fue exitoso
        // Emitimos un evento al componente padre (App.vue) para indicar éxito
        this.$emit('login-success', auth.currentUser);

        console.log('Personal logeado:', auth.currentUser);

      } catch (err) {
        console.error('Error al iniciar sesión del personal:', err.code, err.message);
        switch (err.code) {
          case 'auth/user-not-found':
          case 'auth/wrong-password':
            this.error = 'Email o contraseña incorrectos.';
            break;
          case 'auth/invalid-email':
            this.error = 'Formato de email inválido.';
            break;
          default:
            this.error = 'Error al iniciar sesión. Inténtalo de nuevo.';
        }
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  background-color: #fff;
}
h2 {
  color: #0056b3; /* Un azul para diferenciar del turquesa del paciente */
  margin-bottom: 20px;
}
input {
  width: calc(100% - 20px);
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
button {
  width: 100%;
  padding: 10px;
  background-color: #007bff; /* Azul para el botón */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
button:hover {
  background-color: #0056b3; /* Azul más oscuro */
}
.error-message {
  color: red;
  margin-top: 10px;
}
</style>
